import { Navigate } from 'react-router-dom'
import { isAuthed } from '../../api/auth'

export default function AdminIndex () {
  return isAuthed()
    ? <Navigate to='/admin/dashboard' replace />
    : <Navigate to='/admin/login' replace />
}
